<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 30/11/2021
  -->

<template>
	<div class="qw-row flex-nowrap qw-input-search-root height-input-standard qwoach-form input-background relative"
		 style="padding: 0 !important;">

		<div class="overflow-hidden">

			<transition
				:name="transitionName"
				:duration="transitionAnimationDuration"
				@after-leave="onTransitionCompleted"
				@after-enter="onTransitionCompleted">

				<qw-input
					ref="inputView"
					v-if="!isCollapsableComputed || !isCollapsed"
					v-model="valueData"
					@change="notifyValueChanged"
					style="padding-left: 14px;"
					:style="{width: widthInput}"
					:input-debounce-delay="inputDebounceDelayComputed"
					:disableDebounce="disableDebounceComputed"
					:placeholder="placeholder"
				/>
			</transition>
		</div>

		<div
			@click="onActionButtonClicked"
			class="cursor-pointer"
			style="padding: 0 14px;">

			<div class="qw-input-search-button el-input__suffix relative"
				 style="right: 0">
				<i v-if="showSearchIconComputed" class="fontello icon-search"/>
				<i v-else class="fontello  icon-cancel-circled2"/>
			</div>
		</div>

	</div>

</template>

<script>

import BaseVModelView from "@/core/components/BaseVModelView.vue";
import {QwInputSearchModeEnum} from "@/core/components/Controls/QwInputSearchModeEnum";

export default {
	name: "qw-input-search",
	extends: BaseVModelView,
	inheritAttrs: false,


	props: {
		widthInput: String,
		collapsable: Boolean,
		placeholder: {String, default: "Type to search"},
		isExpanded: Boolean,
		mode: {type: String, default: QwInputSearchModeEnum.TOGGLE},
	},

	data() {
		return {
			isCollapsed: true,
			transitionName: null,
			transitionAnimationDuration: 150,
		}
	},

	created() {
		this.isCollapsed = this.isCollapsedInitialComputed
	},

	mounted() {
		this.syncInputKeyListeners()
	},

	beforeUnmount() {
		this.removeInputKeyListeners()
	},

	methods: {
		setCollapsed(isCollapsed){
			if(this.isCollapsed !== isCollapsed){
				this.toggleCollapse()
			}
		},

		onActionButtonClicked() {
			if(this.isActionModeComputed){
				this.handleActionModeButtonClicked()
			} else {
				this.toggleCollapse()
			}
		},

		handleActionModeButtonClicked() {
			this.$emit("search", this.getValueDataOut())
		},

		syncInputKeyListeners() {
			this.removeInputKeyListeners()
			if(this.isActionModeComputed && this.$refs.inputView?.getInput){
				this.$refs.inputView.getInput().addEventListener("keydown", this.onInputKeyDown)
			}
		},

		removeInputKeyListeners() {
			if(this.$refs.inputView?.getInput){
				this.$refs.inputView.getInput().removeEventListener("keydown", this.onInputKeyDown)
			}
		},

		onInputKeyDown(event) {
			if(event.key === "Enter"){
				event.preventDefault()
				this.$emit("search", this.getValueDataOut())
			}
		},

		async toggleCollapse() {
			this.transitionName = this.isCollapsed ? 'slide' : 'slideBack'
			await this.$nextTickPromise()
			this.isCollapsed = !this.isCollapsed
			if (!this.isCollapsed) {
				this.$emit("collapseChange", this.isCollapsed)
				this.focusSearchInput()
			}
		},

		focusSearchInput() {
			//we need to wait for the animation to finish before focusin. Otherwise this produces visual glitch
			setTimeout(() => {
				if(this.$refs.inputView){
					this.$refs.inputView.focus()
				}
			}, this.transitionAnimationDuration)
		},

		onTransitionCompleted() {
			this.$emit("collapseChange", this.isCollapsed)
		}
	},

	computed: {
		isActionModeComputed() {
			return this.mode === QwInputSearchModeEnum.ACTION
		},

		isCollapsedInitialComputed() {
			let isCollapsed = !this.isExpanded
			if(this.isActionModeComputed){
				isCollapsed = false
			}
			return isCollapsed
		},

		isCollapsableComputed() {
			let isCollapsable = this.collapsable
			if(this.isActionModeComputed){
				isCollapsable = false
			}
			return isCollapsable
		},

		inputDebounceDelayComputed() {
			let inputDebounceDelay = 1000
			if(this.isActionModeComputed){
				inputDebounceDelay = 0
			}
			return inputDebounceDelay
		},

		disableDebounceComputed() {
			return this.isActionModeComputed
		},

		showSearchIconComputed() {
			let isSearchIcon = this.isCollapsed
			if(this.isActionModeComputed){
				isSearchIcon = true
			}
			return isSearchIcon
		},
	}
}
</script>

<style lang="scss">
.qw-input-search-root {

	.el-input__suffix {
		cursor: pointer;
		//border-radius: 50%;
		//width: 1.8rem;
		//height: 1.8rem;
	}

	.el-input__suffix:hover {
		//background-color: rgba(0, 0, 0, 0.04);
	}

	.qw-input-search-button {
		.el-input__icon {
			width: 21px;
		}
	}
}

</style>
